var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptician40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "optician",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    d: "M14.5,6h-0.6766c-0.2828-0.5892-0.8801-1-1.5763-1H9.752C8.9344,5,8.2513,5.5656,8.059,6.3246 C7.8854,6.2835,7.6991,6.25,7.5,6.25S7.1146,6.2834,6.941,6.3245C6.7487,5.5656,6.0654,5,5.2476,5H2.7529 C2.0566,5,1.4592,5.4108,1.1765,6H0.4992C0.2235,6,0,6.2234,0,6.4991v0.0016C0,6.7765,0.2235,7,0.4992,7H1v0.5 C1,9.0889,2.0024,10,3.75,10h0.5C5.9976,10,7,9.0889,7,7.5V7.3413C7.1503,7.2933,7.3307,7.25,7.5,7.25 c0.1693,0,0.3499,0.0433,0.5,0.0913V7.5C8,9.0889,9.002,10,10.75,10h0.5C12.998,10,14,9.0889,14,7.5V7h0.5 C14.7761,7,15,6.7761,15,6.5C15,6.2238,14.7761,6,14.5,6z M6,7.5C6,8.1982,5.8013,9,4.25,9h-0.5C2.1987,9,2,8.1982,2,7.5V6.7524 C2,6.3374,2.3379,6,2.7529,6h2.4946C5.6626,6,6,6.3374,6,6.7524V7.5z M13,7.5C13,8.1982,12.8008,9,11.25,9h-0.5 C9.1992,9,9,8.1982,9,7.5V6.7524C9,6.3374,9.3369,6,9.752,6h2.4951C12.6621,6,13,6.3379,13,6.7529V7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptician40PxSelected);
export default __webpack_public_path__ + "static/media/optician_40px_selected.a4e77607e0e753b102dcea5e90011654.svg";
export { ForwardRef as ReactComponent };